/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".large-banner[_ngcontent-%COMP%], .small-banner[_ngcontent-%COMP%]{display:none}@media (max-width:640px){.small-banner[_ngcontent-%COMP%]{display:flex}}@media (min-width:640px){.large-banner[_ngcontent-%COMP%]{display:flex}}\n/*# sourceMappingURL=edoc-promotion-banner.component.css.map*/"];
export { styles as styles };
